function isNumeric(value: number): boolean {
    return !isNaN(value) && isFinite(value);
}

function getNewAngle (old: number, next: number) {
    let diff = next - old;

    if (diff <= -180) {
        diff += 360;
    }
    if (diff > 180) {
        diff -= 360;
    }

    return old + diff;
}

export default {
    isNumeric: isNumeric,
    getNewAngle: getNewAngle
};




// WEBPACK FOOTER //
// ./src/helpers/math_helpers.ts